<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <div class="logo-text">
            <p>
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
                重庆市兰台档案研究院ICP备案:渝ICP备2022006051号-1
              </a>
            </p>
            <p>客服电话:023-65031293 学院地址:重庆市渝北区仙桃街道重庆新闻传媒大厦24楼</p>
          </div>
        </div>

        <!-- <div class="footer-links">
          <div class="footer-section">
            <h3>学院概况</h3>
            <ul>
              <li><router-link to="/about?tab=学院介绍">学院介绍</router-link></li>
              <li><router-link to="/about?tab=学院风采">学院风采</router-link></li>
            </ul>
          </div>



          <div class="footer-section">
            <h3>培训课程</h3>
            <ul>
              <li><router-link to="/courses">消防培训</router-link></li>
              <li><router-link to="/courses">档案培训</router-link></li>
              <li><router-link to="/courses">新闻培训</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h3>办学特色</h3>
            <ul>
              <li><router-link to="/teachers?tab=师资力量">教材研发</router-link></li>
              <li><router-link to="/teachers?tab=教师风采">沉浸教学</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h3>动态资讯</h3>
            <ul>
              <li><router-link to="/news">行业动态</router-link></li>
            </ul>
          </div>

          <div class="footer-section">
            <h3>学院风采</h3>
            <ul>
              <li><router-link to="/dynamics">员工风采</router-link></li>
              <li><router-link to="/dynamics">学员风采</router-link></li>
              <li><router-link to="/dynamics">学院活动</router-link></li>
            </ul>
          </div>

          <div class="footer-section">
            <h3>关于我们</h3>
            <ul>
              <li><router-link to="/contact">联系电话</router-link></li>
              <li><router-link to="/contact">联系地址</router-link></li>
              <li><router-link to="/contact">加入我们</router-link></li>
            </ul>
          </div>
        </div> -->

        <div class="footer-qrcodes">
          <div class="qrcode">
            <img src="../assets/footright1.png" alt="二维码1" />
            <p>扫码关注公众号</p>
          </div>
          <div class="qrcode">
            <img src="../assets/footright2.png" alt="二维码2" />
            <p>扫码关注公众号</p>
          </div>
        </div>
      </div>

      <!-- <div class="footer-bottom">
        <p>版权所有 © 2024 重庆市兰台档案研究院 | 渝ICP备2022006051号-1</p>
      </div> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  background: #efefef;
  color: #333;
  padding: 40px 0 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 30px;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-logo {
  flex: 0 0 320px;
}

.footer-logo img {
  width: 100%;
  height: 120px;
  object-fit: contain;
}

.logo-text h2 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  font-weight: bold;
  white-space: nowrap;
}

.logo-text p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 5px;
  white-space: nowrap;
}

.logo-text a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.logo-text a:hover {
  color: inherit;
  text-decoration: none;
}

.footer-links {
  flex: 0 0 600px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 5px;
  padding: 0 10px;
}

.footer-qrcodes {
  flex: 0 0 240px;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.qrcode {
  text-align: center;
}

.qrcode img {
  width: 110px;
  height: 110px;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.qrcode img:hover {
  transform: translateY(-2px);
}

.qrcode p {
  color: #666;
  font-size: 14px;
  margin-top: 8px;
}

.footer-section {
  min-width: 90px;
}

.footer-section h3 {
  font-size: 14px;
  margin-bottom: 8px;
  height: 20px;
  line-height: 20px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
}

.footer-section h3::after {
  display: none;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.footer-section ul li {
  line-height: 1.5;
}

.footer-section ul li a {
  color: #666;
  padding: 1px 0;
  font-size: 12px;
  padding-left: 0;
  text-decoration: none;
}

.footer-section ul li a::before {
  display: none;
}

.footer-section ul li a:hover {
  color: #333;
  padding-left: 0;
}

/* 激活状态的路由链接样式 */
.router-link-active {
  color: #333 !important;
  font-weight: 500;
}

.footer-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-top: 20px;
}

/* 响应式布局优化 */
@media (max-width: 1200px) {
  .footer-content {
    flex-direction: column;
  }

  .footer-logo {
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .footer-links {
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 30px;
  }

  .footer-qrcodes {
    justify-content: center;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .site-footer {
    padding: 30px 0 15px;
  }

  .footer-content {
    flex-direction: column;
    gap: 25px;
    margin-bottom: 0;
  }

  .footer-logo {
    flex: none;
    width: 100%;
    text-align: center;
  }

  .logo-text p {
    white-space: normal;
    font-size: 13px;
    line-height: 1.6;
  }

  .footer-links {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    flex: none;
    width: 100%;
  }

  .footer-qrcodes {
    flex: none;
    width: 100%;
    justify-content: center;
    gap: 20px;
  }

  .qrcode img {
    width: 100px;
    height: 100px;
  }

  .qrcode p {
    font-size: 13px;
  }

  .footer-bottom {
    font-size: 12px;
    padding-top: 15px;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .footer-links {
    grid-template-columns: 1fr;
  }

  .footer-qrcodes {
    flex-direction: row;
    gap: 15px;
  }

  .qrcode img {
    width: 90px;
    height: 90px;
  }
}
</style>
